import { CircularProgress, Divider, Stack } from '@mui/joy';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Post from '../../components/core/post/Post';
import { NoData } from '../../components/nodata';
import EditorModal from '../../components/postModal';
import useTopic from '../../hooks/useTopic';
import { useUser } from '../../hooks/useUser';
import TopicModal from '../topics/TopicModal';

export const TopicDetailsContent = (props: {
  showModal: any;
  setModalOpen: any;
}) => {
  const { showModal, setModalOpen } = props;
  const userQuery = useUser();
  const params = useParams();
  const topicQuery = useTopic(params.topicId as string);

  const posts = useMemo(() => {
    if (!topicQuery.isSuccess) return [];
    return topicQuery.data.posts.sort((e1, e2) => {
      const e1Date = new Date(e1.createdAt);
      const e2Date = new Date(e2.createdAt);
      if (e1Date < e2Date) return 1;
      if (e1Date > e2Date) return -1;
      return 0;
    });
  }, [topicQuery]);

  if (!topicQuery.data || !userQuery.isSuccess) {
    return <CircularProgress />;
  }

  return (
    <Stack spacing={2}>
      <EditorModal
        postId={null}
        setOpen={() => {}}
        isOpen={true}
        onPostSubmit={async () => {
          await topicQuery.refetch();
        }}
        asModal={false}
      />
      <Divider />
      <TopicModal
        key="topic_modal"
        handleShowModal={setModalOpen}
        topicId={topicQuery.data._id}
        isOpen={showModal}
      />
      <Stack spacing={3}>
        {/* No topics placeholder */}
        {!posts.length && (
          <div className="w-full flex justify-center pt-[150px]">
            <NoData text="Nog geen berichten" />
          </div>
        )}

        <Stack spacing={2}>
          {posts.map((post) => {
            return (
              <Post
                key={post?._id}
                post={post}
                refetch={topicQuery.refetch}
                hideQuickNavigate={true}
              />
            );
          })}
        </Stack>
      </Stack>
    </Stack>
  );
};
